module.exports = __webpack_public_path__ + "static/img/hm_style_banner_h5.3d21ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/hm_style_banner_h5.png
// module id = Wehb
// module chunks = 34